<script>
    import AjaxText from './AjaxText.vue';

    export default {
        extends: AjaxText,

        childComponent: 'frm-input-smart-data-textarea',
    };
</script>
